var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExportTasks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.72315 1C7.50448 1 7.37019 1.13067 7.30971 1.21472C7.24923 1.29876 7.22322 1.37428 7.19861 1.45374C7.1501 1.612 7.13041 1.79127 7.13041 1.98696V6.77994H5.93229C5.78463 6.77994 5.64823 6.85481 5.5758 6.97498C5.50338 7.09581 5.50619 7.24356 5.58354 7.3611L8.65272 12.0266C8.72725 12.1403 8.85943 12.2105 9.00217 12.2105C9.14491 12.2105 9.27778 12.141 9.35162 12.0273L12.4208 7.36176C12.4981 7.24422 12.501 7.09582 12.4285 6.97498C12.3561 6.85481 12.219 6.77994 12.0713 6.77994H10.8732V1.98696C10.8732 1.79127 10.8535 1.612 10.805 1.45374C10.7811 1.37495 10.7551 1.29878 10.6939 1.21472C10.6335 1.13066 10.4992 1 10.2805 1H7.72315ZM7.97486 1.76435H10.0294C10.0413 1.83002 10.0547 1.8924 10.0547 1.98761V7.16271C10.0547 7.37414 10.2382 7.54422 10.4639 7.54422H11.3421L9.0021 11.0993L6.66624 7.54422H7.54023C7.76594 7.54422 7.94945 7.37349 7.94945 7.16204V1.98696C7.94945 1.89174 7.96291 1.83002 7.97486 1.76435Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.12781H5C3.89543 5.12781 3 5.96406 3 6.99563V12.1322C3 13.1638 3.89543 14 5 14H13C14.1046 14 15 13.1638 15 12.1322V6.99563C15 5.96406 14.1046 5.12781 13 5.12781H11.5",
    stroke: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportTasks);
export default __webpack_public_path__ + "static/media/export-tasks.b6c8dadfbfaaaaa2325949740c032104.svg";
export { ForwardRef as ReactComponent };